import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { format, parseISO } from "date-fns";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { handleAxiosError } from "../../../../common/data/axiosErrorHandler";
import {
  MaintenanceDashboardApiFactory,
  VehicleDiagnosticRecord,
} from "../../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../../common/hooks/useAxiosInstance";
import { useTableHeaderStyles } from "../common";
import { Empty } from "../widgets/Empty";
import { Widget } from "../widgets/Widget";
import { VehicleWidgetProps } from "./VehicleWidgetProps";
import styles from "./UnacknowledgedVehicleDiagnosticErrors.module.css";
import { BooleanField, Record } from "react-admin";

export const VehicleDiagnosticErrors = forwardRef(
  ({ className, icon, title, vehicle, ...rest }: VehicleWidgetProps, ref) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<VehicleDiagnosticRecord[]>();
    const axios = useAxiosInstance();
    const classes = useTableHeaderStyles();

    const loadData = useCallback(() => {
      if (!axios) {
        return;
      }

      if (!vehicle?.id) {
        return;
      }

      setLoading(true);
      MaintenanceDashboardApiFactory(undefined, axios.defaults.baseURL, axios)
        .apiAppMaintenancedashboardActivevehiclediagnosticerrorsVehicleIdGet(
          vehicle.id
        )
        .then((result) => {
          setData(result.data);
        })
        .catch((e) => console.error(handleAxiosError(e)))
        .finally(() => setLoading(false));
    }, [axios, vehicle]);

    useEffect(() => {
      loadData();
    }, [loadData]);

    return (
      <Widget
        title={title}
        icon={icon}
        className={className}
        ref={ref}
        {...rest}>
        <div className="categories">
          {loading ? (
            <div className="category">
              <CircularProgress size="3rem" />
            </div>
          ) : data && data.length ? (
            <div className="table-wrapper">
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow className={classes.tableHead}>
                      <TableCell>Code</TableCell>
                      <TableCell>Time</TableCell>
                      <TableCell>Active</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.map((dtc) => (
                      <TableRow key={dtc.id} className={styles.alert}>
                        <TableCell>
                          <Tooltip title={dtc.description!} arrow>
                            <Typography variant="body2" className={styles.code}>
                              {dtc.code}
                            </Typography>
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          {format(parseISO(dtc.time!), "MMM do, yyyy")}
                        </TableCell>
                        <TableCell>
                          <BooleanField
                            source="isActive"
                            record={dtc as Record}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ) : (
            <Empty />
          )}
        </div>
      </Widget>
    );
  }
);
